import styled from 'styled-components';
import { Caption as DefaultCaption } from 'components/Typography';
import { Form as FormikForm } from 'formik';
import DefaultButton from 'components/Buttons/Button';
import DefaultInput from 'components/Form/Input';
import DefaultLogo from 'components/Logo';
import addAlpha from 'utils/addAlpha';
import { Label } from 'components/Form/Input/styles';

// TODO: TFR-44 move to container group or do not export
export const Container = styled.div`
  background: ${({ theme }) => theme.colors.white};
  width: 34.5rem;
  border-radius: 1.5rem;
  padding: 3rem 4rem;
  text-align: center;
  align-self: center;
  margin: 0 auto;
`;

// TODO: TFR-45:Logo make unique name or do not export
export const Logo = styled(DefaultLogo)`
  margin-bottom: 2.5rem;
  max-width: 13.025rem;
`;

// TODO: TFR-49 make separate component. Probably - form helpers etc. This is not unique for input. It could be reused in other form sections
export const ForgetButton = styled.button`
  color: ${({ theme }) => theme.colors.navyGreen};
  margin-top: 1rem;
  align-self: flex-end;
  background: none;
  border: none;
  background: none;
  cursor: pointer;
  width: fit-content;
`;

// TODO: TFR-45:Button make unique name or do not export
export const Button = styled(DefaultButton)`
  margin-top: 2.5rem;
  margin-bottom: 1.5rem;
`;

// TODO: TFR-49 make separate component. Probably - form helpers etc. This is not unique for input. It could be reused in other form sections
export const Caption = styled(DefaultCaption)`
  margin: 0 auto;
  color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
`;

// TODO: TFR-49 make separate component. Probably - form helpers etc. This is not unique for input. It could be reused in other form sections
export const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  text-align: left;
`;

// TODO: TFR-45:Input make unique name or do not export
export const Input = styled(DefaultInput)`
  :not(:first-child) {
    margin-top: 3rem;
  }
  ${Label} {
    color: ${({ theme }) => addAlpha(theme.colors.navyGreen, 0.8)};
  }
`;
